var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");

if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}


link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}



	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([189bfop]|1s|4p|a2|ef|ft|hm|j3|lc|ot|pe|qe|qi|zk)|n([07biq]|[9cw]5|23|2u|57|bx|do|jx|pb|ya|ze)|2(57|7y|8|ce|ci|d6|g3|hd|k4)|f([flmpw]|2j|4t|bm|d3|n7|ob|rd|sl|to|vi|wi|wn|x5)|q(15|4|4j|j7|k4|mc|v0|w|wy|x6|yb)|w([278ejw]|0q|1v|57|a6|cf|cx|gz|ld|ry|v4)|z([09abcgjmwy]|51|81|dw|f4|xm)|o([18ux]|4n|dj|f6|fo|hu|wf|wz|zc)|k([3fhwz]|1f|1z|4h|89|f4|lb|me|q9|r2|ya|zb)|d([2efhikrz]|30|4j|cm|gb|o4|pi|v7)|l([cdkqu]|b0|h5|h8|iy|sj|ym)|7([aijw]|2[adg]|5z|a2|gn)|b([kmnvz]|3t|bh|kn|oc|sc|xt)|9([0abdekls]|87|9u|gn|j2|mq|p9|q6)|r([19chjmqs]|02|7a|ge|gw|hk|n6|oo|xd|zx)|0([9dgjkp]|1k|1q|ag|aj|bc|ig|jt|q9|vb|xz)|t([2cdin]|3w|51|a6|ah|gm|l3|llv|n9|qd|qs|ue)|i([5chkou]|r[4iz]|10|18|99|a2|ap|b6|ix|kr|lw|nj|ns|ot|wl)|x([dly]|z[cnt]|2y|4x|9l|bv|g3|gd|hy|jm|mx|rh|yc)|h([1ep]|a[58o]|[4wy]z|4b|cx|g2|gj|j6|t8|up|zq)|j(29|4|7g|a4|dp|he|i|l7|pn|vb|wb|wf)|3([deq]|71|92|fl|h7|r4|wj|zr)|s([9bcl]|0a|3s|61|d9|ex|he|hs|kd|kj|me|r3|tz|vp)|v([7apru]|k(du|h|n)|9l|b3|ct|mk|n4|og|oh|ws)|1([179fiouw]|00|8m|f1|jf|mu|qo|rv|x7)|8([28fhrt]|e[8ks]|1s|gu|hi|k2|nm|ov|qc|w4|xc|yo)|g([19ex]|ho|yb|yf|zt)|p([dswz]|2k|3x|6o|ia|n8|yv)|4([17ehv]|17|76|7e|ea|eg|ft|nb|uu|v5)|a([27jnw]|3u|7y|9o|ck|cv|do|ef|fc|ik|k3|rf|s1)|5([4579]|00|0s|1p|6n|6p|g7|hx|mz|rd|s9)|c([4dkmuz]|23|4t|8a|mi|n9)|6([13cdgvy]|3t|6x|8y|cd|fq|fu|jg|ns|v8|vyp)|u(2l|8d|cj|dt|gm|hn|hz|u8|v|w8|wq|x)|e([2459fr]|2b|ah|av|lr|mz|tk3|vi|vw|wc|wo)|y(2q|7n|ek|g7|ji|k|l8|y))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
